import { createInertiaApp, router } from '@inertiajs/svelte';
import { mount } from 'svelte';
import * as Sentry from '@sentry/svelte';
import { setDisplayTimezone } from './utils/dates';

Sentry.init({
    dsn: 'https://71bfc39764223e00e8ea76b0b5afa4b9@o4507838858461184.ingest.us.sentry.io/4511055876194304',
    sendDefaultPii: true,
});

let wasAuthenticated: boolean | null = null;

function checkAuth(page: { url: string; props: Record<string, any> }): void {
    const isAuthenticated = !!page.props.auth?.user;

    if (wasAuthenticated !== null && wasAuthenticated !== isAuthenticated) {
        wasAuthenticated = isAuthenticated;
        window.location.href = page.url;
        return;
    }

    wasAuthenticated = isAuthenticated;

    if (page.props.auth?.user?.needs_onboarding && !page.url.startsWith('/onboarding')) {
        router.visit('/onboarding');
    }
}

createInertiaApp({
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.svelte', { eager: true }) as Record<string, any>;
        const page = pages[`./Pages/${name}.svelte`];
        return { default: page.default, layout: page.layout };
    },
    setup({ el, App, props }) {
        setDisplayTimezone((props.initialPage.props as any).timezone ?? 'UTC');
        mount(App, { target: el, props });

        checkAuth(props.initialPage as any);
    },
    defaults: {
        visitOptions: () => ({ viewTransition: true }),
    },
});

router.on('navigate', (event) => {
    checkAuth(event.detail.page);
});
